import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
dayjs.extend(isSameOrAfter);

export function isDate(value: string): boolean {
  if (!value) return false;
  if (!dayjs(value).isSameOrAfter(dayjs("01-01-1900"))) return false;
  if (dayjs(value).isSameOrAfter(dayjs("01-01-3000"))) return false;

  //these first four checks validate all acceptable forms of user text input
  //the last check validates dates coming from the date picker
  if (
    dayjs(value).format("MM/DD/YYYY") !== value &&
    dayjs(value).format("MM/D/YYYY") !== value &&
    dayjs(value).format("M/DD/YYYY") !== value &&
    dayjs(value).format("M/D/YYYY") !== value &&
    dayjs(value).format("YYYY-MM-DD") !== value
  )
    return false;

  return dayjs(value).isValid();
}

export function isFromDateBeforeToDate(
  fromDate: string | Date,
  toDate: string | Date
): boolean {
  return dayjs(toDate).isSameOrAfter(dayjs(fromDate));
}
